import axios from 'axios';

const API_BASE_URL = `${global.config.apiDomain}/mc-user/web/vtb`;
const GET_TRANSACTION_URL = `${global.config.apiDomain}/mc-user/web/vtb/get-transaction`;

const headers = {
  "Content-Type": "application/json"
};

const handleResponse = (response) => {
  if (!response.data) {
    throw new Error('No data received from server');
  }
  return response.data;
};

const handleError = (error) => {
  const message = error.response?.data?.message || error.message || 'An error occurred';
  throw new Error(message);
};

export const vietinBankService = {
  getAccounts: async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/get-accounts`,
        {},
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  createOrUpdateAccount: async (accountData) => {
    try {
      if (!accountData.accountNumber || !accountData.username || !accountData.propType) {
        throw new Error('Missing required fields');
      }
      const response = await axios.post(
        `${API_BASE_URL}/create-or-update`,
        accountData,
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  deleteAccounts: async (accountIds) => {
    try {
      if (!accountIds || accountIds.length === 0) {
        throw new Error('Account IDs are required');
      }

      for (const id of accountIds) {
        const response = await axios.post(
          `${API_BASE_URL}/delete/${id}`,
          {},
          { headers }
        );
        const data = handleResponse(response);
        if (data?.status && data.status !== "OK") {
          throw new Error(data.message || `Delete failed for account ${id}`);
        }
      }

      return {
        status: "OK",
        message: "Xoá tài khoản thành công"
      };
    } catch (error) {
      return handleError(error);
    }
  },

  getTransactions: async (accountId) => {
    try {
      const response = await axios.get(
        `${GET_TRANSACTION_URL}?id=${accountId}`,
        {},
        { headers }
      );
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  }
};
